import axios from "axios"

export const loadCategories = async ({organizationId}) => {
    const {data} = await axios.get('/api/categories/'+organizationId)
    return data
}